import styled from "styled-components";
import { useNavigate, useSearchParams, } from "react-router-dom";
import { getTheme, Bell, Box, Div, VBox, Gear, } from "@bracket/ui";
import { useMessaging, useUI, useWallet, } from "@bracket/platform/store";



export declare type QuickNavItemsProps = {
	align?: "center" | "flex-end";
	justify?: "center" | "flex-end";
};

export const QuickNavItems = ({
	align,
	justify,
}: QuickNavItemsProps) => {

	const { address, anonymous, } = useWallet();
	const { unread, } = useMessaging();
	const { setMenuState, } = useUI();
	const navigate = useNavigate();
	const [ searchParams, ] = useSearchParams();

	const handleNotificationsClick = () => {
		const path = "/settings/notifications";
		navigate(size === 0 ? path : `${path}?${params}`);
		setMenuState("CLOSED");
	};

	const handleSettingsClick = () => {
		const path = "/settings/account";
		navigate(size === 0 ? path : `${path}?${params}`);
		setMenuState("CLOSED");
	};

	const params = searchParams;
	const { size, } = searchParams;

	return (
		<Brace $align={align} $justify={justify} $flexible>
			<IconsContainer $align={align} $justify={justify}>
				{ address && !anonymous && <IconWrapper onClick={handleNotificationsClick}><Bell />{ unread > 0 && <NotificationBadge>{unread}</NotificationBadge> }</IconWrapper> }
				{ address && !anonymous && <IconWrapper onClick={handleSettingsClick}><Gear /></IconWrapper> }
			</IconsContainer>
		</Brace>
	);

};

const Brace = styled(VBox)<{ $align?: "center" | "flex-end"; $justify?: "center" | "flex-end" }>`
	align-items: ${props => props.$align || "center"};
	justify-content: ${props => props.$justify || "center"};
	gap: 1rem;
`;

const IconsContainer = styled(Box)<{ $align?: "center" | "flex-end"; $justify?: "center" | "flex-end" }>`
	align-items: ${props => props.$align || "center"};
	justify-content: ${props => props.$justify || "center"};
	gap: 1.5rem;
	@media (min-width: 1024px) {
		margin-left: 1.5rem;
	}
`;

const IconWrapper = styled(Div)`
	position: relative;
	cursor: pointer;
	&:hover {
		opacity: 0.8;
	}
`;

const NotificationBadge = styled(Div)`
	position: absolute;
	top: -0.5rem;
	right: -0.5rem;
	background: ${() => getTheme().primary};
	color: ${() => getTheme().primary_on};
	border-radius: 50%;
	min-width: 1.25rem;
	height: 1.25rem;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 0.75rem;
	font-weight: 500;
`;
